import axios from 'axios'
import { config, url } from '@/store'

// Заказы\заявки
const getOrderList = (params) => {
  return axios.get(`${url}/pvc?expand=status,delivery,client,gauger,order_type,installer,creator,comments&${params.searchFilter}&sort=${(params.orderDir || '') + (params.orderBy || 'id')}&per-page=${params.currentTake}&page=${params.currentPage}${params.tabFilter ? '&search[' + params.tabFilter + ']' : ''}`, config)
}
const deleteOrderList = (orderId) => {
  return new Promise((resolve, reject) => {
    axios.delete(`${url}/pvc/${orderId}`, config).then(res => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}
const addOrderToElect = (ids) => {
  return new Promise((resolve, reject) => {
    axios.post(`${url}/pvc/favorites`, { order_ids: ids }, config).then(res => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}
const deleteOrderFromElect = (ids) => {
  return new Promise((resolve, reject) => {
    axios.delete(`${url}/pvc/favorites`, { data: { order_ids: ids }, ...config }).then(res => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// Апдейт\создание заказа
const getOrderUpdateInfo = (params) => {
  return axios.get(`${url}/pvc/${params.id}?${params.expands}`, config)
}
const postOrder = (createData) => {
  return axios.post(`${url}/pvc`, createData, config)
}
const putOrder = (createData, orderId) => {
  return axios.put(`${url}/pvc/${orderId}`, createData, config)
}
const postOrderComments = (id, commentData) => {
  return axios.post(`${url}/pvc/${id}/comment`, commentData, config)
}
const putOrderComments = (id, commentData, commentId) => {
  return axios.put(`${url}/pvc/${id}/comment/${commentId}`, commentData, config)
}
const deleteOrderComments = (id, commentId) => {
  return axios.delete(`${url}/pvc/${id}/comment/${commentId}`, config)
}

// Способ доставки
const getDelivType = (params) => {
  return axios.get(`${url}/pvc-delivery?expand=orders&${params.searchFilter}&orderBy=id&orderDir=DESC&per-page=${params.take}&page=${params.page}`, config)
}
const postDelivType = (createData) => {
  return axios.post(`${url}/pvc-delivery`, createData, config)
}
const putDelivType = (updateData, typeId) => {
  return axios.put(`${url}/pvc-delivery/${typeId}`, updateData, config)
}
const deleteDelivType = (typeId) => {
  return axios.delete(`${url}/pvc-delivery/${typeId}`, config)
}

// Тип информирования клиента
const getInformType = (params) => {
  return axios.get(`${url}/pvc-informer?expand=clients&${params.searchFilter}&orderBy=id&orderDir=DESC&per-page=${params.take}&page=${params.page}`, config)
}
const postInformType = (createData) => {
  return axios.post(`${url}/pvc-informer`, createData, config)
}
const putInformType = (updateData, typeId) => {
  return axios.put(`${url}/pvc-informer/${typeId}`, updateData, config)
}
const deleteInformType = (typeId) => {
  return axios.delete(`${url}/pvc-informer/${typeId}`, config)
}

// Тип расходов
const getCostType = (params) => {
  return axios.get(`${url}/pvc-cost-type?expand=orders&${params.searchFilter}&orderBy=id&orderDir=DESC&per-page=${params.take}&page=${params.page}`, config)
}
const postCostType = (createData) => {
  return axios.post(`${url}/pvc-cost-type`, createData, config)
}
const putCostType = (updateData, typeId) => {
  return axios.put(`${url}/pvc-cost-type/${typeId}`, updateData, config)
}
const deleteCostType = (typeId) => {
  return axios.delete(`${url}/pvc-cost-type/${typeId}`, config)
}

// Тип приходов
const getIncomingType = (params) => {
  return axios.get(`${url}/pvc-income-type?expand=orders,incomes&${params.searchFilter}&orderBy=id&orderDir=DESC&per-page=${params.take}&page=${params.page}`, config)
}
const postIncomingType = (createData) => {
  return axios.post(`${url}/pvc-income-type`, createData, config)
}
const putIncomingType = (updateData, typeId) => {
  return axios.put(`${url}/pvc-income-type/${typeId}`, updateData, config)
}
const deleteIncomingType = (typeId) => {
  return axios.delete(`${url}/pvc-income-type/${typeId}`, config)
}

// Список клиентов
const getClientList = (params) => {
  return axios.get(`${url}/pvc-client?expand=orders,informer&${params.searchFilter}&orderBy=id&orderDir=DESC&per-page=${params.take}&page=${params.page}`, config)
}
const deleteClientList = (typeId) => {
  return axios.delete(`${url}/pvc-client/${typeId}`, config)
}

// Апдейт\создание клиента
const getClientUpdateInfo = (params) => {
  return axios.get(`${url}/pvc-client/${params.id}?${params.expands}`, config)
}
const postClientUpdateSaveInfo = (createData) => {
  return axios.post(`${url}/pvc-client`, createData, config)
}
const putClientUpdate = (updateData, id) => {
  return axios.put(`${url}/pvc-client/${id}`, updateData, config)
}

// Список ролей
const getRoleList = (params) => {
  return axios.get(`${url}/pvc-right?expand=orders&${params.searchFilter}&orderBy=id&orderDir=DESC&per-page=${params.take}&page=${params.page}`, config)
}
const deleteRoleList = (typeId) => {
  return axios.delete(`${url}/pvc-right/${typeId}`, config)
}

// Апдейт\создание роли
const getRoleUpdateInfo = (params) => {
  return axios.get(`${url}/pvc-right/${params.id}?${params.expands}`, config)
}
const postRoleUpdateSaveInfo = (createData) => {
  return axios.post(`${url}/pvc-right`, createData, config)
}
const putRoleUpdate = (updateData, id) => {
  return axios.put(`${url}/pvc-right/${id}`, updateData, config)
}

// Список статусов
const getStatusList = (params) => {
  return axios.get(`${url}/pvc-status?expand=orders&${params.searchFilter}&orderBy=id&orderDir=DESC&per-page=${params.take}&page=${params.page}&per-page=${params.perPage}`, config)
}
const deleteStatusList = (typeId) => {
  return axios.delete(`${url}/pvc-status/${typeId}`, config)
}

// Список типов заказов
const getOrderTypeList = (params) => {
  return axios.get(`${url}/pvc-type?expand=statuses,orders&${params.searchFilter}&orderBy=id&orderDir=DESC&per-page=${params.take}&page=${params.page}`, config)
}
const deleteOrderTypeList = (typeId) => {
  return axios.delete(`${url}/pvc-type/${typeId}`, config)
}

// Апдейт\создание типа заказов
const getOrderTypeUpdateInfo = (params) => {
  return axios.get(`${url}/pvc-type/${params.id}?${params.expands}`, config)
}
const postOrderTypeUpdateSaveInfo = (createData) => {
  return axios.post(`${url}/pvc-type`, createData, config)
}
const putOrderTypeUpdate = (updateData, id) => {
  return axios.put(`${url}/pvc-type/${id}`, updateData, config)
}

// Апдейт статусов
const getStatusUpdateInfo = (params) => {
  return axios.get(`${url}/pvc-status/${params.id}?${params.expands}`, config)
}
const postStatusUpdateSaveInfo = (createData) => {
  return axios.post(`${url}/pvc-status`, createData, config)
}
const putStatusUpdate = (updateData, id) => {
  return axios.put(`${url}/pvc-status/${id}`, updateData, config)
}

export default {
  getOrderList,
  deleteOrderList,
  getOrderUpdateInfo,
  postOrder,
  putOrder,
  postOrderComments,
  putOrderComments,
  deleteOrderComments,
  getDelivType,
  postDelivType,
  putDelivType,
  deleteDelivType,
  getInformType,
  postInformType,
  putInformType,
  deleteInformType,
  getCostType,
  postCostType,
  putCostType,
  deleteCostType,
  getIncomingType,
  postIncomingType,
  putIncomingType,
  deleteIncomingType,
  getClientList,
  deleteClientList,
  getClientUpdateInfo,
  postClientUpdateSaveInfo,
  putClientUpdate,
  getRoleList,
  deleteRoleList,
  getRoleUpdateInfo,
  postRoleUpdateSaveInfo,
  putRoleUpdate,
  getStatusList,
  deleteStatusList,
  getStatusUpdateInfo,
  postStatusUpdateSaveInfo,
  putStatusUpdate,
  getOrderTypeList,
  deleteOrderTypeList,
  getOrderTypeUpdateInfo,
  postOrderTypeUpdateSaveInfo,
  putOrderTypeUpdate,
  addOrderToElect,
  deleteOrderFromElect
}
